import { Eye, Users } from "lucide-react"

import { cn } from "@/lib/utils"

// The controlled two-button pill bar. Custom pills (not shadcn Tabs) because the
// design carries a count badge inside each pill. `tab` is the active key
// ("by" | "with"); onChange flips it in the page.
const TABS = [
  { key: "by", label: "Shared by me", Icon: Users, countKey: "sharedByMe" },
  { key: "with", label: "Shared with me", Icon: Eye, countKey: "sharedWithMe" },
]

export default function AccessTabs({ tab, counts, onChange }) {
  return (
    <div className="mb-[18px] flex gap-[7px]">
      {TABS.map(({ key, label, Icon, countKey }) => {
        const on = tab === key

        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-pressed={on}
            className={cn(
              "flex items-center gap-2 rounded-[10px] border px-[15px] py-[9px] text-[13px] font-semibold transition-colors",
              on
                ? "border-foreground bg-foreground text-background dark:border-primary dark:bg-primary dark:text-primary-foreground"
                : "border-border bg-card text-muted-foreground hover:text-foreground"
            )}
          >
            <Icon className={cn("size-4", !on && "text-ink-3")} strokeWidth={1.85} />
            {label}
            <span
              className={cn(
                "rounded-full px-[7px] py-px text-[11px] font-bold",
                on ? "bg-white/20 text-current" : "bg-secondary text-ink-3"
              )}
            >
              {counts?.[countKey] ?? 0}
            </span>
          </button>
        )
      })}
    </div>
  )
}
